
<section class="content">
  <div class="row">
    <div class="col-lg-2">
      <div class="card shadow-sm bg-info info-box">
        <div class="card-body">
          <div class="inner">
            <h3>{{numberOfActiveVessels}}</h3>
            <p>Active vessels</p>
          </div>
          <div class="icon">
            <i class="icon icon-bag"></i>
          </div>
        </div>
      </div>
    </div>
    <div class="col-lg-2">
      <div class="card shadow-sm bg-info info-box">
        <div class="card-body">
          <div class="inner">
            <h3>{{minAge}} - {{maxAge}}</h3>
            <p>Age range</p>
          </div>
          <div class="icon">
            <i class="icon icon-bag"></i>
          </div>
        </div>
      </div>
    </div>
    <div class="col-lg-3">
      <div class="card shadow-sm bg-info info-box">
        <div class="card-body">
          <div class="inner">
            <h3>{{minCapacityMT | number : '1.0-0'}} - {{maxCapacityMT | number
            : '1.0-0'}}</h3>
            <p>Capacity range</p>
          </div>
          <div class="icon">
            <i class="icon icon-bag"></i>
          </div>
        </div>
      </div>
    </div>
    <div class="col-lg-3">
      <div class="card shadow-sm bg-info info-box">
        <div class="card-body">
          <div class="inner">
            <h3>{{minGrt | number}} - {{maxGrt | number}}</h3>
            <p>GRT range</p>
          </div>
          <div class="icon">
            <i class="icon icon-bag"></i>
          </div>
        </div>
      </div>
    </div>
    <div class="col-lg-2">
      <div class="card shadow-sm bg-info info-box">
        <div class="card-body">
          <div class="inner">
            <h3>{{biggestFlag}}</h3>
            <p>With {{numberOfBiggestFlag}} vessels</p>
          </div>
          <div class="icon">
            <i class="icon icon-bag"></i>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="row">
    @for (v of filteredVessels; track $index) {
      <div class="col-md-2">
        <div class="card shadow-sm">
          <img [src]="photos[v.imo]" class="card-img-top" alt="{{v.name?.name}}"
            style="height: 10rem">
            <div class="card-body">
              <a id="edit"
                class="btn btn-link text-decoration-none p-0"
                [routerLink]="['/vessels/vessel/', v.imo]">
                <h5>{{v.name?.name}}</h5>
              </a>
              <p class="card-text">
                IMO: {{v.imo}}<br />
                GRT: {{v.spec?.dimensionsCapacities?.grt | number}}<br />
                Age: {{calculateVesselAge(v)}}<br />
                @if (findLatestQ88(v) && findLatestQ88(v)?.documentId) {
                  <span [ngClass] ="{'text-red': checQ88Expirey(v)}">
                    Q88: {{findLatestQ88(v)?.issueDate | date}}
                    <a class="btn btn-link"
                      (click)="downloadFile(findLatestQ88(v)?.documentId! , v.name?.name + '-Q88')">
                      <i class="fa fa-download" aria-hidden="true"></i></a>
                    </span>
                  }
                  <br />
                </div>
              </div>
            </div>
          }
        </div>
      </section>
